// Mutations
export const SET_PERMISSIONS = 'SET_PERMISSIONS';

// Actions
export const INIT_PERMISSIONS = 'INIT_PERMISSIONS';
